<template>
  <div class="py-2 w-full flex flex-col gap-y-2 border-t border-brand-gray-300">
    <CollapsibleSection>
      <div class="flex flex-col gap-y-1 text-brand-black-secondary">
        <div class="w-full flex flex-col md:flex-row gap-x-3 font-sans text-xs">
          <h3 class="w-full md:w-2/12">{{ $t('requestNumber') }}:</h3>
          <span class="text-brand-black-body max-w-prose">
            {{ request.typingCenterRegRequest.requestNumber }}
          </span>
        </div>
        <div class="w-full flex flex-col md:flex-row gap-x-3 font-sans text-xs">
          <h3 class="w-full md:w-2/12">{{ $t('administration') }}:</h3>
          <span class="text-brand-black-body max-w-prose">
            {{ request.typingCenterRegRequest.admninstrativeRegions.text }}
          </span>
        </div>
        <div class="w-full flex flex-col md:flex-row gap-x-3 font-sans text-xs">
          <h3 class="w-full md:w-2/12">{{ $t('ServiceTransactions') }}:</h3>
          <span class="text-brand-black-body max-w-prose">
            {{ request.typingCenterRegRequest.serviceTransactionName }}
          </span>
        </div>
        <div
          v-if="
            request.typingCenterRegRequest.refundedFeesAmount &&
            request.typingCenterRegRequest.serviceTransactionId == icaRefund &&
            request.isApprove
          "
          class="w-full flex gap-x-3 font-sans text-xs"
        >
          <h3>{{ $t('refundedAmount') }}:</h3>
          <span class="text-brand-black-body max-w-prose">
            {{ intlNumberFormat.format(request.typingCenterRegRequest.refundedFeesAmount) }}
          </span>
        </div>
      </div>
    </CollapsibleSection>

    <!-- TODO: update delivery action -->
    <!-- TODO: update appointment -->
    <!-- TODO: showUpdateDeliverySection -->
    <div
      v-if="
        request.typingCenterRegRequest.lookupLastActionId == 5 &&
        request.typingCenterRegRequest.serviceTransId == 708
      "
    >
      <!-- TODO: danger infobar -->
    </div>

    <div v-if="isIcaTypingCenterRegistration">
      <!-- TODO -->
      <!-- <ul ng-if="!isDraft" class="nav navbar-nav navbar-right nav-bar-action">
        <li uib-dropdown keyboard-nav class="action_li">
          <span
            class="btn btn-xs btn-gray bg-gd-dk"
            uib-dropdown-toggle
            uib-tooltip="{{ 'Action' | translate }}"
            ><i class="fa fa-bars" aria-hidden="true"></i
          ></span>
          <ul class="dropdown-menu animated fadeInUp" uib-dropdown-menu role="menu">
            <li ng-click="downloadReceipt(requestLastHis.requestNumber)">
              <button type="button" class="btn btn-link">{{ 'PrintFees' | translate }}</button>
            </li>
            <li ng-if="typingCenterRegRequest.lookupLastActionId == 4">
              <button type="button" ng-click="login(typingCenterRegRequest)" class="btn btn-link">
                {{ 'inComplete' | translate }}
              </button>
            </li>
            <li ng-if="typingCenterRegRequest.lookupLastActionId == 37">
              <button type="button" class="btn btn-link" ng-click="goToPayDeposit()">
                {{ 'payDeposit' | translate }}
              </button>
            </li>
          </ul>
        </li>
      </ul> -->
    </div>

    <!-- TODO: !isIcaTypingCenterRegistration && !isDraft -->
    <!-- TODO: isIcaTypingCenterRegistration && !isDraft buttons list -->
    <!-- TODO: !isDraft && requestHis != undefined && requestHis.length > 0 -->
    <div v-if="request.isDraft && request.history?.length > 0">
      <!-- TODO -->
    </div>

    <div v-if="!request.isDraft && request.history?.length > 0">
      <DataTable
        :default-headers="['requestActions', 'transactionDate', 'actionComment']"
        :data-set="requestHistoryDataSet"
      ></DataTable>
    </div>
  </div>
</template>

<script setup>
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { DateTime } from 'luxon'
import DataTable from '@/components/DataTable/index.vue'

const props = defineProps({
  request: Object
})

const i18n = useI18n()
const intlNumberFormat = Intl.NumberFormat('AE-en', { style: 'currency', currency: 'AED' })

const formatDate = (date) => DateTime.fromISO(date).toFormat('dd/MM/yyyy HH:mm:ss a')

const requestHistoryDataSet = computed(() => {
  if ((props.request?.history ?? []).length === 0) return null

  return props.request?.history.map((h) => {
    let actionComment = h.actionComment
    if (props.request.showOverstayedPermitLastEntryDate) {
      if (h.actionId == 6) {
        actionComment = [h.lastEntryDateMessage, formatDate(h.actionComment)].join(' ')
      }
    }
    return {
      requestActions: h.action.text,
      transactionDate: formatDate(h.date),
      actionComment
    }
  })
})
</script>

<style lang="scss" scoped></style>
